/* Let's Mix — product page: variant picker, gallery, quantity, sticky bar */
(function () {
  'use strict';

  function money(cents, fmt) {
    var v = (cents / 100).toFixed(2);
    if (fmt && fmt.indexOf('{{') > -1) return fmt.replace(/\{\{\s*amount[^}]*\}\}/, v);
    return '£' + v;
  }

  function initProduct(root) {
    var section = root.querySelector ? root.querySelector('[data-lm-pdp]') : null;
    if (root.matches && root.matches('[data-lm-pdp]')) section = root;
    if (!section || section.__lmInit) return;
    section.__lmInit = true;

    var dataEl = section.querySelector('[data-lm-product-json]');
    var product = dataEl ? JSON.parse(dataEl.textContent) : null;
    var fmt = section.getAttribute('data-money-format') || '';
    var form = section.querySelector('form[data-lm-pdp-form]');
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var priceNow = section.querySelector('[data-lm-price-now]');
    var priceWas = section.querySelector('[data-lm-price-was]');
    var priceSave = section.querySelector('[data-lm-price-save]');
    var perServe = section.querySelector('[data-lm-per-serve]');
    var servings = parseInt(section.getAttribute('data-servings') || '0', 10);
    var addBtn = form ? form.querySelector('[data-lm-add]') : null;
    var stickyPrice = section.querySelector('[data-lm-sticky-price]');
    var stickyBtn = section.querySelector('[data-lm-sticky-add]');

    /* ---- gallery ---- */
    var mains = section.querySelectorAll('.lm-gallery__main img');
    var thumbs = section.querySelectorAll('.lm-gallery__thumb');
    function showMedia(id) {
      var found = false;
      mains.forEach(function (img) { var on = img.getAttribute('data-media-id') === String(id); img.classList.toggle('is-active', on); if (on) found = true; });
      thumbs.forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-media-id') === String(id)); });
      return found;
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { showMedia(t.getAttribute('data-media-id')); }); });

    /* ---- variants ---- */
    function selectedOptions() {
      var opts = [];
      section.querySelectorAll('[data-lm-option]').forEach(function (group) {
        var checked = group.querySelector('input:checked');
        var sel = group.querySelector('select');
        opts.push(checked ? checked.value : (sel ? sel.value : null));
      });
      return opts;
    }
    function findVariant(opts) {
      if (!product) return null;
      /* single-variant products (no option groups) — use the form's variant id */
      if (!section.querySelector('[data-lm-option]') || product.variants.length === 1) {
        var cur = idInput ? String(idInput.value) : '';
        return product.variants.find(function (v) { return String(v.id) === cur; }) || product.variants[0] || null;
      }
      return product.variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); }) || null;
    }
    function updateAvailability(variant) {
      /* mark pills sold-out relative to the current selection of other options */
      section.querySelectorAll('[data-lm-option]').forEach(function (group, idx) {
        group.querySelectorAll('input').forEach(function (input) {
          var opts = selectedOptions(); opts[idx] = input.value;
          var v = findVariant(opts);
          var label = input.nextElementSibling;
          if (label) label.classList.toggle('is-soldout', !v || !v.available);
        });
      });
    }
    function render(variant) {
      if (!variant) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = addBtn.getAttribute('data-unavailable') || 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (priceNow) priceNow.textContent = money(variant.price, fmt);
      if (priceWas) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) { priceWas.textContent = money(variant.compare_at_price, fmt); priceWas.hidden = false; if (priceSave) { priceSave.textContent = 'Save ' + Math.round((1 - variant.price / variant.compare_at_price) * 100) + '%'; priceSave.hidden = false; } }
        else { priceWas.hidden = true; if (priceSave) priceSave.hidden = true; }
      }
      if (perServe && servings > 0) {
        var units = parseInt(perServe.getAttribute('data-units-' + variant.id) || '1', 10) || 1;
        perServe.textContent = money(Math.round(variant.price / (servings * units)), fmt);
      }
      if (stickyPrice) stickyPrice.textContent = money(variant.price, fmt);
      var label = variant.available ? (addBtn ? addBtn.getAttribute('data-label') : 'Add to bag') : (addBtn ? addBtn.getAttribute('data-soldout') : 'Sold out');
      [addBtn, stickyBtn].forEach(function (b) { if (!b) return; b.disabled = !variant.available; if (!b.getAttribute('data-state')) b.textContent = label; });
      section.querySelectorAll('[data-lm-variant-title]').forEach(function (el) { el.textContent = variant.title; });
      if (variant.featured_media && variant.featured_media.id) showMedia(variant.featured_media.id);
      if (history.replaceState) {
        var url = new URL(window.location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url.toString());
      }
      updateAvailability(variant);
      var bundleEl = section.querySelector('[data-lm-bundle]');
      if (bundleEl) { var isCase = /case|pack/i.test(variant.title || ''); var saving = variant.price * (parseInt(bundleEl.getAttribute('data-qty'), 10) || 3) - parseInt(bundleEl.getAttribute('data-bundle-price'), 10); bundleEl.hidden = isCase || saving <= 0; var t = bundleEl.querySelector('[data-lm-bundle-text]'); if (t && !isCase && saving > 0) t.textContent = bundleEl.getAttribute('data-text').replace('[saving]', money(saving, fmt)).replace('[price]', money(parseInt(bundleEl.getAttribute('data-bundle-price'), 10), fmt)); }
      section.dispatchEvent(new CustomEvent('lm:variant:change', { bubbles: true, detail: { variant: variant } }));
    }
    section.querySelectorAll('[data-lm-option] input, [data-lm-option] select').forEach(function (el) {
      el.addEventListener('change', function () { render(findVariant(selectedOptions())); });
    });
    if (product) render(findVariant(selectedOptions()));

    /* ---- quantity ---- */
    section.querySelectorAll('.lm-qty').forEach(function (q) {
      var input = q.querySelector('input');
      q.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var n = parseInt(input.value, 10) || 1;
          n += b.getAttribute('data-dir') === '-' ? -1 : 1;
          input.value = Math.max(1, n);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });

    /* ---- sticky mobile bar ---- */
    var bar = section.querySelector('.lm-stickybar');
    if (bar && addBtn && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var e = entries[0];
        bar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      }, { threshold: 0 });
      io.observe(addBtn);
      if (stickyBtn) stickyBtn.addEventListener('click', function () {
        if (form) { form.requestSubmit ? form.requestSubmit() : form.querySelector('[type=submit]').click(); }
      });
    }
  }

  function boot(root) { initProduct(root || document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
